import styled from 'styled-components'
import { rem } from 'utils/common'
import { device } from 'components/Variable'

export const LogoStyle = styled.div`
	display: block;

	img,
	svg {
		display: block;
		max-width: 100%;
		max-height: ${rem(38)};
		@media (${device.mobileL}) {
			max-height: ${rem(32)};
		}
	}
`
